// src/components/TopNav/PagesTopNav.js
// Header for the public pages (about, features, pricing, contact) and for the onboarding pages
// (KYC, trial). Signed out: links + Sign in / Get started. Signed in: who you are + Sign out.
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FiLogOut, FiMenu, FiX } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import "../../pages/cx.css"; // theme tokens (--accent ...)
import "./PagesTopNav.css";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About us" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/support", label: "Support" },
  { to: "/contact", label: "Contact" },
];

const ONBOARDING = ["/setup-hotel", "/kyc"];

export default function PagesTopNav() {
  const { pathname } = useLocation();
  const { authData, handleLogout } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [pathname]);

  const signedIn = !!authData?.token;
  const onboarding = ONBOARDING.some((p) => pathname.startsWith(p));
  const showLinks = !(signedIn && onboarding);

  const name = authData?.username || authData?.firstName || authData?.email || "Account";
  const initial = String(name).trim().charAt(0).toUpperCase() || "U";

  return (
    <header className="pn-header">
      <div className="pn-inner">
        <Link to="/" className="pn-logo" aria-label="Nnetego home">
          <img src="/images/logo.png" alt="Nnetego" />
        </Link>

        {showLinks && (
          <nav className={`pn-nav ${open ? "is-open" : ""}`} aria-label="Main">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `pn-link ${isActive ? "is-active" : ""}`}>
                {l.label}
              </NavLink>
            ))}

            {/* inside the mobile menu the account actions live here too */}
            {!signedIn && (
              <div className="pn-nav-actions">
                <Link to="/login" className="pn-btn pn-btn--ghost">
                  Sign in
                </Link>
                <Link to="/register" className="pn-btn">
                  Get started
                </Link>
              </div>
            )}
          </nav>
        )}

        <div className="pn-right">
          {signedIn ? (
            <>
              <span className="pn-user" title={name}>
                <span className="pn-avatar" aria-hidden="true">
                  {initial}
                </span>
                <span className="pn-user-name">{name}</span>
                {authData?.role && <span className="pn-role">{authData.role}</span>}
              </span>
              <button type="button" className="pn-btn pn-btn--ghost pn-signout" onClick={handleLogout}>
                <FiLogOut /> <span>Sign out</span>
              </button>
            </>
          ) : (
            <div className="pn-guest">
              <Link to="/login" className="pn-btn pn-btn--ghost">
                Sign in
              </Link>
              <Link to="/register" className="pn-btn">
                Get started
              </Link>
            </div>
          )}

          {showLinks && (
            <button type="button" className="pn-burger" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen((o) => !o)}>
              {open ? <FiX /> : <FiMenu />}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
